var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.69519 2.99547C1.69519 2.55073 2.0532 2.19531 2.48855 2.19531L7.73803 2.19531C8.17338 2.19531 8.53139 2.55074 8.53139 2.99547V4.7189H6.26204C5.13072 4.7189 4.21868 5.6396 4.21868 6.76905V9.03151H2.48855C2.0532 9.03151 1.69519 8.67609 1.69519 8.23136L1.69519 2.99547ZM4.21868 10.2815H2.48855C1.35722 10.2815 0.44519 9.36081 0.44519 8.23136L0.44519 2.99547C0.44519 1.86602 1.35722 0.945313 2.48855 0.945313L7.73803 0.945313C8.86936 0.945313 9.78139 1.86602 9.78139 2.99547V4.7189H11.5115C12.6429 4.7189 13.5549 5.6396 13.5549 6.76905L13.5549 12.0049C13.5549 13.1344 12.6429 14.0551 11.5115 14.0551L6.26204 14.0551C5.13072 14.0551 4.21868 13.1344 4.21868 12.0049V10.2815ZM9.78139 5.9689L11.5115 5.9689C11.9469 5.9689 12.3049 6.32432 12.3049 6.76905L12.3049 12.0049C12.3049 12.4497 11.9469 12.8051 11.5115 12.8051L6.26204 12.8051C5.8267 12.8051 5.46868 12.4497 5.46868 12.0049L5.46868 10.2815L7.73803 10.2815C8.86936 10.2815 9.78139 9.36081 9.78139 8.23136L9.78139 5.9689ZM8.53139 5.9689L8.53139 8.23136C8.53139 8.67609 8.17338 9.03151 7.73803 9.03151L5.46868 9.03151V6.76905C5.46868 6.32432 5.8267 5.9689 6.26204 5.9689H8.53139Z",
    fill: "#01021D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyBlack);
export default __webpack_public_path__ + "static/media/copy-black.c6832e0899260d6bb7346326f8d45f25.svg";
export { ForwardRef as ReactComponent };